import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, createBlock as _createBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withKeys as _withKeys, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox } from "vue"
import _imports_0 from '@/assets/common/img/skilup-top_title.png'


const _hoisted_1 = {
  key: 0,
  id: "com_form_contet1"
}
const _hoisted_2 = { class: "errorform" }
const _hoisted_3 = {
  key: 0,
  class: "error-message"
}
const _hoisted_4 = {
  key: 1,
  class: "com_page_title1"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "com_inner1 clearfix" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "block1" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_0,
      alt: "",
      class: "image1"
    })
  ])
], -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = {
  key: 2,
  id: "contents1"
}
const _hoisted_8 = { class: "com_sec1" }
const _hoisted_9 = { class: "com_inner1 clearfix" }
const _hoisted_10 = { class: "com_l_banner1" }
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "com_contents2" }
const _hoisted_13 = { class: "main_column1" }
const _hoisted_14 = {
  key: 0,
  class: "error-message"
}
const _hoisted_15 = { key: 1 }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("p", { class: "text1" }, [
  /*#__PURE__*/_createElementVNode("span", null, "スキルアップ動画一覧")
], -1)
const _hoisted_17 = { class: "com_i_title1 a" }
const _hoisted_18 = ["src"]
const _hoisted_19 = /*#__PURE__*/_createElementVNode("h2", null, "新着動画", -1)
const _hoisted_20 = { class: "com_thumb_list1 com_more2" }
const _hoisted_21 = { class: "thumb1 a" }
const _hoisted_22 = ["src", "onError"]
const _hoisted_23 = { class: "meta1" }
const _hoisted_24 = {
  key: 0,
  class: "com_tag3"
}
const _hoisted_25 = {
  key: 1,
  class: "com_tag4"
}
const _hoisted_26 = { class: "com_tag2" }
const _hoisted_27 = {
  key: 2,
  class: "edit1"
}
const _hoisted_28 = ["onClick"]
const _hoisted_29 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_30 = [
  _hoisted_29
]
const _hoisted_31 = { class: "body1" }
const _hoisted_32 = { class: "com_link1" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("span", null, "もっと見る", -1)
const _hoisted_34 = [
  _hoisted_33
]
const _hoisted_35 = { class: "com_i_title1 a com_mgt45" }
const _hoisted_36 = ["src"]
const _hoisted_37 = { class: "com_thumb_list1 com_more2" }
const _hoisted_38 = { class: "thumb1 a" }
const _hoisted_39 = ["src", "onError"]
const _hoisted_40 = { class: "meta1" }
const _hoisted_41 = {
  key: 0,
  class: "com_tag3"
}
const _hoisted_42 = {
  key: 1,
  class: "com_tag4"
}
const _hoisted_43 = {
  key: 2,
  class: "edit1"
}
const _hoisted_44 = ["onClick"]
const _hoisted_45 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_46 = [
  _hoisted_45
]
const _hoisted_47 = { class: "body1" }
const _hoisted_48 = { class: "com_link1" }
const _hoisted_49 = ["onClick"]
const _hoisted_50 = /*#__PURE__*/_createElementVNode("span", null, "もっと見る", -1)
const _hoisted_51 = [
  _hoisted_50
]
const _hoisted_52 = { key: 2 }
const _hoisted_53 = { class: "com_search_result_hd1" }
const _hoisted_54 = { class: "text1" }
const _hoisted_55 = { class: "com_thumb_list1 com_more2" }
const _hoisted_56 = { class: "thumb1 a" }
const _hoisted_57 = ["src", "onError"]
const _hoisted_58 = { class: "meta1" }
const _hoisted_59 = {
  key: 0,
  class: "com_tag3"
}
const _hoisted_60 = {
  key: 1,
  class: "com_tag4"
}
const _hoisted_61 = { class: "com_tag2" }
const _hoisted_62 = {
  key: 2,
  class: "edit1"
}
const _hoisted_63 = ["onClick"]
const _hoisted_64 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_65 = [
  _hoisted_64
]
const _hoisted_66 = { class: "body1" }
const _hoisted_67 = { class: "com_link1" }
const _hoisted_68 = { class: "side_search_option1" }
const _hoisted_69 = { key: 0 }
const _hoisted_70 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_71 = /*#__PURE__*/_createElementVNode("h2", { class: "title1" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "com_icon_option1" }),
  /*#__PURE__*/_createTextVNode("絞り込み検索 ")
], -1)
const _hoisted_72 = { class: "block_search1" }
const _hoisted_73 = /*#__PURE__*/_createElementVNode("h3", { class: "title2" }, "キーワードから探す", -1)
const _hoisted_74 = {
  key: 1,
  class: "error-message"
}
const _hoisted_75 = { class: "block_options_group1" }
const _hoisted_76 = { class: "com_checkbox1" }
const _hoisted_77 = /*#__PURE__*/_createElementVNode("span", { class: "t1 com_fs14" }, "未視聴の動画のみ表示", -1)
const _hoisted_78 = {
  key: 0,
  class: "com_checkbox1"
}
const _hoisted_79 = /*#__PURE__*/_createElementVNode("span", { class: "t1 com_fs14" }, "掲載期間外も表示する", -1)
const _hoisted_80 = { class: "block_options_group1" }
const _hoisted_81 = { class: "com_center1 com_mgb10" }
const _hoisted_82 = /*#__PURE__*/_createElementVNode("span", { class: "com_icon_cross1" }, null, -1)
const _hoisted_83 = /*#__PURE__*/_createElementVNode("h3", { class: "title2" }, "カテゴリーから探す", -1)
const _hoisted_84 = { class: "hd1" }
const _hoisted_85 = { class: "com_checkbox1" }
const _hoisted_86 = ["onUpdate:modelValue", "onChange"]
const _hoisted_87 = { class: "t1" }
const _hoisted_88 = { class: "body1" }
const _hoisted_89 = ["onUpdate:modelValue", "onChange"]
const _hoisted_90 = { class: "t2" }
const _hoisted_91 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_92 = { class: "com_center1 com_mgt5" }
const _hoisted_93 = /*#__PURE__*/_createElementVNode("span", { class: "com_icon_cross1" }, null, -1)
const _hoisted_94 = { class: "side_right1" }
const _hoisted_95 = { key: 3 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_header_component = _resolveComponent("header-component")!
  const _component_loading_overlay = _resolveComponent("loading-overlay")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_content_pagination = _resolveComponent("content-pagination")!
  const _component_SkilupSideSliderComponent = _resolveComponent("SkilupSideSliderComponent")!
  const _component_FooterComponent = _resolveComponent("FooterComponent")!
  const _component_BackToTop = _resolveComponent("BackToTop")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createVNode(_component_header_component)
    ]),
    (_ctx.isInitError)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            (_ctx.apiErrorMessage)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.apiErrorMessage), 1))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_loading_overlay, {
      active: _ctx.isLoading,
      "onUpdate:active": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isLoading) = $event)),
      "is-full-page": true
    }, null, 8, ["active"]),
    (_ctx.isDataFetched)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_6))
      : _createCommentVNode("", true),
    (_ctx.isDataFetched)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("section", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_component_router_link, { to: "/skilup-toranomaki" }, {
                  default: _withCtx(() => [
                    _createElementVNode("img", {
                      src: 
                _ctx.appDir +
                '/images/k042_td_20250516_agent_insight_bnr_toranoaki_w860.png'
              ,
                      alt: "",
                      class: "banner1"
                    }, null, 8, _hoisted_11)
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  (_ctx.apiErrorMessage)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(_ctx.apiErrorMessage), 1))
                    : _createCommentVNode("", true),
                  (!_ctx.isSerched)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                        _hoisted_16,
                        _createElementVNode("div", _hoisted_17, [
                          _createElementVNode("div", null, [
                            _createElementVNode("img", {
                              src: _ctx.appDir + '/images/icon-t-movie2.png',
                              alt: "",
                              class: "icon-t-movie"
                            }, null, 8, _hoisted_18),
                            _hoisted_19
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_20, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getDisplayedNewVideo(
                    _ctx.videoList,
                    _ctx.isNewVideoOpen
                  ), (item) => {
                            return (_openBlock(), _createBlock(_component_router_link, {
                              key: item.contentsId,
                              class: "item1",
                              to: `/${item.detailPath}/categoryId/${item.categoryId}/contentsId/${item.contentsId}`
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", null, [
                                  _createElementVNode("div", _hoisted_21, [
                                    (item.thumbnailPath && item.thumbnailName)
                                      ? (_openBlock(), _createElementBlock("img", {
                                          key: 0,
                                          src: 
                          `/${item.thumbnailPath}/${item.thumbnailName}` +
                          '?v=' +
                          new Date().getTime()
                        ,
                                          alt: "",
                                          onError: ($event: any) => (_ctx.handleImageError(item))
                                        }, null, 40, _hoisted_22))
                                      : _createCommentVNode("", true)
                                  ])
                                ]),
                                _createElementVNode("div", null, [
                                  _createElementVNode("div", _hoisted_23, [
                                    (item.isWatched)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_24, "視聴済"))
                                      : (_openBlock(), _createElementBlock("span", _hoisted_25, "未視聴")),
                                    _createElementVNode("span", _hoisted_26, _toDisplayString(item.phaseName), 1),
                                    (_ctx.isKaunetAdmin)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                                          _createElementVNode("a", {
                                            href: "#",
                                            onClick: _withModifiers(($event: any) => (
                            _ctx.editContents(
                              item.categoryId,
                              item.contentsId,
                              item.updateFormPath
                            )
                          ), ["prevent"]),
                                            class: "com_edit1"
                                          }, _hoisted_30, 8, _hoisted_28)
                                        ]))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _createElementVNode("div", _hoisted_31, [
                                    _createElementVNode("h2", null, [
                                      _createElementVNode("p", _hoisted_32, _toDisplayString(item.videoTitle), 1)
                                    ]),
                                    _createElementVNode("p", null, _toDisplayString(item.videoCaption), 1)
                                  ])
                                ])
                              ]),
                              _: 2
                            }, 1032, ["to"]))
                          }), 128)),
                          (_ctx.newVideoListLength > _ctx.newVideoDefaultDispCnt)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: _normalizeClass({ open1: _ctx.isNewVideoOpen })
                              }, [
                                _createElementVNode("span", {
                                  class: "more_button1",
                                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggleNewVideoOpen()))
                                }, _hoisted_34)
                              ], 2))
                            : _createCommentVNode("", true)
                        ]),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.phaseListData, (phase) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: `${phase.categoryId}-${phase.phaseId}`
                          }, [
                            _createElementVNode("div", _hoisted_35, [
                              _createElementVNode("div", null, [
                                _createElementVNode("img", {
                                  src: 
                        _ctx.appDir +
                        `/images/${phase.iconFileName}` +
                        '?v=' +
                        new Date().getTime()
                      ,
                                  alt: "",
                                  class: "icon-t-movie"
                                }, null, 8, _hoisted_36),
                                _createElementVNode("h2", null, _toDisplayString(phase.phaseName), 1)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_37, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getContentsByPhase(
                      phase.categoryId,
                      phase.phaseId,
                      phase.isOpen
                    ), (capter) => {
                                return (_openBlock(), _createBlock(_component_router_link, {
                                  key: capter.categoryId + capter.contentsId,
                                  class: "item1",
                                  to: `/${capter.detailPath}/categoryId/${capter.categoryId}/contentsId/${capter.contentsId}`
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_38, [
                                      _createElementVNode("img", {
                                        src: 
                          `/${capter.thumbnailPath}/${capter.thumbnailName}` +
                          '?v=' +
                          new Date().getTime()
                        ,
                                        alt: "",
                                        onError: ($event: any) => (_ctx.handleImageError(capter))
                                      }, null, 40, _hoisted_39)
                                    ]),
                                    _createElementVNode("div", null, [
                                      _createElementVNode("div", _hoisted_40, [
                                        (capter.isWatched)
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_41, "視聴済"))
                                          : (_openBlock(), _createElementBlock("span", _hoisted_42, "未視聴")),
                                        (_ctx.isKaunetAdmin)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                                              _createElementVNode("a", {
                                                href: "#",
                                                onClick: _withModifiers(($event: any) => (
                              _ctx.editContents(
                                capter.categoryId,
                                capter.contentsId,
                                capter.updateFormPath
                              )
                            ), ["prevent"]),
                                                class: "com_edit1"
                                              }, _hoisted_46, 8, _hoisted_44)
                                            ]))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _createElementVNode("div", _hoisted_47, [
                                        _createElementVNode("h2", null, [
                                          _createElementVNode("p", _hoisted_48, _toDisplayString(capter.videoTitle), 1)
                                        ]),
                                        _createElementVNode("p", null, _toDisplayString(capter.videoCaption), 1)
                                      ])
                                    ])
                                  ]),
                                  _: 2
                                }, 1032, ["to"]))
                              }), 128)),
                              (
                      _ctx.getContentsByPhaseLength(
                        phase.categoryId,
                        phase.phaseId
                      ) > _ctx.defaultDispCnt
                    )
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 0,
                                    class: _normalizeClass({ open1: phase.isOpen })
                                  }, [
                                    _createElementVNode("span", {
                                      class: "more_button1",
                                      onClick: ($event: any) => (_ctx.togglePhaseVideoOpen(phase))
                                    }, _hoisted_51, 8, _hoisted_49)
                                  ], 2))
                                : _createCommentVNode("", true)
                            ])
                          ]))
                        }), 128))
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_52, [
                        _createElementVNode("div", _hoisted_53, [
                          _createElementVNode("div", null, [
                            _createElementVNode("p", _hoisted_54, [
                              _createElementVNode("span", null, _toDisplayString(_ctx.dispKeyWord), 1),
                              _createTextVNode(_toDisplayString(_ctx.dispTitle), 1)
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_55, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paginatedData, (item) => {
                            return (_openBlock(), _createBlock(_component_router_link, {
                              key: item.categoryId + item.contentsId,
                              class: "item1",
                              to: `/${item.detailPath}/categoryId/${item.categoryId}/contentsId/${item.contentsId}`
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", null, [
                                  _createElementVNode("div", _hoisted_56, [
                                    (item.thumbnailPath && item.thumbnailName)
                                      ? (_openBlock(), _createElementBlock("img", {
                                          key: 0,
                                          src: 
                          `/${item.thumbnailPath}/${item.thumbnailName}` +
                          '?v=' +
                          new Date().getTime()
                        ,
                                          alt: "",
                                          onError: ($event: any) => (_ctx.handleImageError(item))
                                        }, null, 40, _hoisted_57))
                                      : _createCommentVNode("", true)
                                  ])
                                ]),
                                _createElementVNode("div", null, [
                                  _createElementVNode("div", _hoisted_58, [
                                    (item.isWatched)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_59, "視聴済"))
                                      : (_openBlock(), _createElementBlock("span", _hoisted_60, "未視聴")),
                                    _createElementVNode("span", _hoisted_61, _toDisplayString(item.phaseName), 1),
                                    (_ctx.isKaunetAdmin)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                                          _createElementVNode("a", {
                                            href: "#",
                                            onClick: _withModifiers(($event: any) => (
                            _ctx.editContents(
                              item.categoryId,
                              item.contentsId,
                              item.updateFormPath
                            )
                          ), ["prevent"]),
                                            class: "com_edit1"
                                          }, _hoisted_65, 8, _hoisted_63)
                                        ]))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _createElementVNode("div", _hoisted_66, [
                                    _createElementVNode("h2", null, [
                                      _createElementVNode("p", _hoisted_67, _toDisplayString(item.videoTitle), 1)
                                    ]),
                                    _createElementVNode("p", null, _toDisplayString(item.videoCaption), 1)
                                  ])
                                ])
                              ]),
                              _: 2
                            }, 1032, ["to"]))
                          }), 128))
                        ]),
                        _createVNode(_component_content_pagination, {
                          "current-page": _ctx.currentPage,
                          "total-pages": _ctx.totalPages,
                          "items-per-page": _ctx.itemsPerPage,
                          onPageChanged: _ctx.handlePageChange
                        }, null, 8, ["current-page", "total-pages", "items-per-page", "onPageChanged"])
                      ]))
                ]),
                _createElementVNode("div", _hoisted_68, [
                  (_ctx.isSerched)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_69, [
                        _createElementVNode("button", {
                          type: "button",
                          class: "button1",
                          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.backInitDisp && _ctx.backInitDisp(...args)))
                        }, " 初期表示に戻す "),
                        _hoisted_70
                      ]))
                    : _createCommentVNode("", true),
                  _hoisted_71,
                  _createElementVNode("div", _hoisted_72, [
                    _hoisted_73,
                    _createElementVNode("div", null, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        name: "",
                        placeholder: "キーワードを入力",
                        onKeyup: _cache[3] || (_cache[3] = _withKeys(
//@ts-ignore
(...args) => (_ctx.narrowSearch && _ctx.narrowSearch(...args)), ["enter"])),
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.narrowKeyword) = $event)),
                        maxlength: "50"
                      }, null, 544), [
                        [_vModelText, _ctx.narrowKeyword]
                      ]),
                      _createElementVNode("button", {
                        type: "button",
                        name: "",
                        onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.narrowSearch && _ctx.narrowSearch(...args)))
                      })
                    ])
                  ]),
                  (_ctx.errorMessage)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_74, _toDisplayString(_ctx.errorMessage), 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_75, [
                    _createElementVNode("label", _hoisted_76, [
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        name: "",
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.isUnWatchedOnly) = $event))
                      }, null, 512), [
                        [_vModelCheckbox, _ctx.isUnWatchedOnly]
                      ]),
                      _hoisted_77
                    ]),
                    (_ctx.isKaunetAdmin)
                      ? (_openBlock(), _createElementBlock("label", _hoisted_78, [
                          _withDirectives(_createElementVNode("input", {
                            type: "checkbox",
                            name: "",
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.isOutsidePostPeriod) = $event))
                          }, null, 512), [
                            [_vModelCheckbox, _ctx.isOutsidePostPeriod]
                          ]),
                          _hoisted_79
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("button", {
                      type: "button",
                      class: "button1",
                      onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.narrowSearch && _ctx.narrowSearch(...args)))
                    }, " 検索 ")
                  ]),
                  _createElementVNode("div", _hoisted_80, [
                    _createElementVNode("div", _hoisted_81, [
                      _createElementVNode("a", {
                        href: "javascript:void(0)",
                        class: "option_uncheck_all1 com_link1",
                        onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.uncheckAll && _ctx.uncheckAll(...args)))
                      }, [
                        _hoisted_82,
                        _createTextVNode("チェックを外す ")
                      ])
                    ]),
                    _hoisted_83,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groupedTags, (group, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: index,
                        class: "option_group1"
                      }, [
                        _createElementVNode("div", _hoisted_84, [
                          _createElementVNode("label", _hoisted_85, [
                            _withDirectives(_createElementVNode("input", {
                              type: "checkbox",
                              "onUpdate:modelValue": ($event: any) => ((group.isPhaseChecked) = $event),
                              onChange: ($event: any) => (_ctx.togglePhase(group))
                            }, null, 40, _hoisted_86), [
                              [_vModelCheckbox, group.isPhaseChecked]
                            ]),
                            _createElementVNode("span", _hoisted_87, _toDisplayString(group.phaseName), 1)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_88, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.tags, (tag, idx) => {
                            return (_openBlock(), _createElementBlock("label", {
                              key: idx,
                              class: "com_checkbox1"
                            }, [
                              _withDirectives(_createElementVNode("input", {
                                type: "checkbox",
                                "onUpdate:modelValue": ($event: any) => ((tag.isChecked) = $event),
                                onChange: ($event: any) => (_ctx.checkPhaseStatus(group, tag))
                              }, null, 40, _hoisted_89), [
                                [_vModelCheckbox, tag.isChecked]
                              ]),
                              _createElementVNode("span", _hoisted_90, _toDisplayString(tag.tagName), 1)
                            ]))
                          }), 128))
                        ])
                      ]))
                    }), 128)),
                    _hoisted_91,
                    _createElementVNode("button", {
                      type: "button",
                      class: "button1",
                      onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.narrowSearch && _ctx.narrowSearch(...args)))
                    }, " 検索 "),
                    _createElementVNode("div", _hoisted_92, [
                      _createElementVNode("a", {
                        href: "javascript:void(0)",
                        class: "option_uncheck_all1 com_link1",
                        onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.uncheckAll && _ctx.uncheckAll(...args)))
                      }, [
                        _hoisted_93,
                        _createTextVNode("チェックを外す")
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_94, [
                  _createVNode(_component_SkilupSideSliderComponent)
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.isDataFetched)
      ? (_openBlock(), _createElementBlock("div", _hoisted_95, [
          _createVNode(_component_FooterComponent)
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_BackToTop)
  ], 64))
}